import { Box, styled } from "@mui/material";

export const AddMigrationWrapper = styled(Box)(({ theme }) => {
	return {
		overflow: "hidden",
		"& .fieldset-wrapper-I": {
			padding: "var(--basic-padding) calc(var(--basic-padding)/1.5)",
			border: "1px solid #D7D7D7",
			borderRadius: "20px",
			overflow: "hidden",
			marginBlockEnd: "var(--basic-margin)",
		},
		"& .fieldset-wrapper-II": {
			padding: "var(--basic-padding) calc(var(--basic-padding)/1.5)",
			border: "1px solid #D7D7D7",
			borderRadius: "20px",
			overflow: "hidden",
		},
		"& fieldset": {
			display: "flex",
			flexDirection: "column",
		},
		"& .file-box": {
			padding: "var(--basic-padding)",
			border: "1px solid #D7D7D7",
			borderRadius: "20px",
			overflow: "hidden",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			"& .MuiInputBase-root": {
				boxShadow: "none",
			},
		},
		"& .button-box": {
			marginBlockStart: "var(--basic-margin)",
		},
		"& .MuiInputBase-root": {
			border: "none",
			boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
		},
		"& thead tr": {
			backgroundColor: "#842581",
			"& th": {
				color: "#FFFFFF",
				border: "1px solid #D9D9D9",
			},
		},
		"tbody tr": {
			"& td": {
				border: "1px solid #D9D9D9",
			},
			"& td:last-child": {
				width: "10%",
				whiteSpace: "nowrap",
			},
		},
		[theme.breakpoints.up("miniTablet")]: {
			"& .fieldset-wrapper-II": {
				maxWidth:
					"calc((var(--flex-gap) / 2 * 2) + calc(var(--basic-padding)/2 * 3) + 30rem)",
			},
		},
	};
});
